// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import { Box, Typography } from '@mui/material';
import FormDialog from '../../../components/Dialog/FormDialog';

interface CreateAllocationConfirmationProps {
  open: boolean;
  onClose: () => void;
  onCreateAllocation: (() => Promise<unknown>) | undefined;
}

export const CreateAllocationConfirmationDialog: React.FC<CreateAllocationConfirmationProps> = ({
  open,
  onClose,
  onCreateAllocation,
}) => {
  const handleSubmit = React.useCallback(() => {
    if (onCreateAllocation) {
      return onCreateAllocation().finally(() => {
        onClose();
      });
    }
    onClose();
    return Promise.resolve();
  }, [onClose, onCreateAllocation]);
  return (
    <FormDialog
      open={open}
      title="Create Allocation"
      onCancel={onClose}
      onSubmit={handleSubmit}
      submitName="Allocate"
    >
      <Box>
        <Typography sx={{ mt: 2 }} variant="body2">
          Would you like to continue?
        </Typography>
      </Box>
    </FormDialog>
  );
};
